import { formatterMask } from '../../../../common/utils/configFormField';

// Корректирую пришедшие данные (удаляю всё ненужное и убираю лишнюю вложенность)
export const dataAdjustmentResponse = data => {
  let newData = {};
  newData.profileId = data.profileId;
  if (data.userId) {
    newData.userId = data.userId.userId;
    newData.photo = data.userId.photo;
    newData.lastname = data.userId.lastname;
    newData.name = data.userId.name;
    newData.patronymic = data.userId.patronymic;
    newData.phone = data.userId.phone;
    if (data.userId.phone) {
      let phone = data.userId.phone.match(
        /^(\+7|\+380|\+375|\+995|\+374|\+994|\+77|)(.*)/
      );
      newData.phoneMask =
        (phone[1] ? phone[1] + ' ' : '') +
        (phone[2] ? formatterMask(phone[2], '(###) ###-##-##') : '');
    }
  }
  if (data.roleId) {
    newData.roleKey = data.roleId.roleKey;
    newData.role = data.roleId.role;
    newData.roleId = data.roleId.roleId;
  }
  if (data.companyId) {
    newData.companyTypeId = data.companyId.companyTypeId;
    // newData.companyType = data.companyId.companyType;
    newData.nameLegal = data.companyId.nameLegal;
  }
  newData.updatedAt = data.updatedAt;
  newData.createdAt = data.createdAt;
  if (data.profileStatusId) {
    newData.profileStatusKey = data.profileStatusId.profileStatusKey;
    newData.profileStatus = data.profileStatusId.profileStatus;
  }
  newData.lastActivity = data.lastActivity;
  return newData;
};
